export default {
  helpCategory: "HelpCategory",
  addHelpCategory: "AddHelpCategory",
  editHelpCategory: "EditHelpCategory",
};
